import {
  BankidIcon,
  BodyText,
  Button,
  MailIcon,
  Stack
} from '@kvdbil/components';
import React from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from '~/Locale';
import { SignInOption } from '../types';

const StyledOptionsButton = styled(Button).attrs({ type: 'button' })`
  gap: 1rem;
`;

const centerText = css`
  text-align: center;
`;

const StyledBodyText = styled(BodyText)`
  ${centerText}
`;

export type SignInOptionButtonsProps = {
  activeSignInOption: SignInOption;
  onPressBankId: () => void;
  onPressEmail: () => void;
  forceDisableBankId?: boolean;
};

export const SignInOptionButtons = ({
  activeSignInOption,
  onPressBankId,
  onPressEmail,
  forceDisableBankId = false
}: SignInOptionButtonsProps) => {
  const { t } = useTranslation();

  const showBankId = activeSignInOption !== 'BANKID' && !forceDisableBankId;
  const showEmail = activeSignInOption !== 'EMAIL';

  if (!showBankId && !showEmail) {
    return null;
  }

  return (
    <Stack rowGap={0.5}>
      <StyledBodyText>{t('...or sign in with:')}</StyledBodyText>
      {showBankId && (
        <StyledOptionsButton
          variant="outline"
          size="regular"
          color="neutral"
          onClick={onPressBankId}
          fullWidth
          data-testid="sign-in-with-bankid"
        >
          <BankidIcon fontSize="1.5rem" />
          {t('BankID')}
        </StyledOptionsButton>
      )}
      {showEmail && (
        <StyledOptionsButton
          variant="outline"
          size="regular"
          color="neutral"
          onClick={onPressEmail}
          fullWidth
          data-testid="sign-in-with-email"
        >
          <MailIcon fontSize="1.5rem" />
          {t('Email')}
        </StyledOptionsButton>
      )}
    </Stack>
  );
};
